import { useSelector, useDispatch } from 'react-redux';
import { getUserId } from 'store/selectors/user';
import {
  getShowingAggregateByUserIdEffect,
  setShowingsAggregateFilterEffect,
  setShowingsFiltersAppliedEffect,
  setShowingsTabEffect,
} from 'store/effects/showingAggregate';
import { FilterSections } from './FilterSections';
import {
  getActiveShowingTabSelector,
  getShowingFilterSelector,
  getShowingIsArchiveSelector,
} from 'store/selectors/showingAggregate';
import {
  ArchiveShowingsStatus,
  ShowingFilterStatus,
  showingsFilters,
} from 'settings/constants/showings';

export const Filter = () => {
  const dispatch = useDispatch();
  const userId = useSelector(getUserId);
  const { isArchive } = useSelector(getShowingIsArchiveSelector);
  const { activeShowingTab } = useSelector(getActiveShowingTabSelector);

  const { showingsFilter } = useSelector(getShowingFilterSelector);

  const prepareFilters = (filters) => {
    return {
      ...filters,
      ...(showingsFilter === showingsFilters.myShowings && { isMyShowing: true }),
    };
  };

  const doneHandler = (filterValues) => {
    dispatch(setShowingsFiltersAppliedEffect(true));

    const filters = prepareFilters(filterValues);

    dispatch(setShowingsAggregateFilterEffect(filters));
    activeShowingTab && dispatch(setShowingsTabEffect(null));

    dispatch(
      getShowingAggregateByUserIdEffect({
        id: userId,
        filters,
      }),
    );
  };

  const resetHandler = () => {
    dispatch(setShowingsFiltersAppliedEffect(false));
    const filterStatuses = { ...ShowingFilterStatus, ...ArchiveShowingsStatus };

    const statusValues = Object.values(filterStatuses);

    const filters = prepareFilters({ Status: statusValues });

    activeShowingTab && dispatch(setShowingsTabEffect(null));

    dispatch(setShowingsAggregateFilterEffect({}));

    dispatch(
      getShowingAggregateByUserIdEffect({
        id: userId,
        filters,
      }),
    );
  };

  return <FilterSections key={isArchive} onDone={doneHandler} onReset={resetHandler} />;
};
